import { Component, OnInit, Inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { environment } from "@env/environment";
import { SettingsService } from "@shared/services/settings.service";
import { SharedService } from "@shared/services/shared.service";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { ISelectItems } from "@shared/models/selectItems";
import { IPublicComplaint } from "app/models/complaints/public-complaint";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { TranslateService } from "@ngx-translate/core";
import { PublicComplaintService } from "app/services/complaint/public-complaint.service";
import { DOCUMENT } from '@angular/common';
import { Title } from '@angular/platform-browser';

@Component({
  selector: "app-public-complaint",
  templateUrl: "./public-complaint.component.html",
  styleUrls: ["./public-complaint.component.scss"]
})

export class PublicComplaintComponent implements OnInit {
  defaultRoute: string = 'dashboard';
  route: string = 'route';
  redirectFromProfile: string = 'redirectFromProfile';
  loggingIn: boolean = false;
  authType: string = environment.auth.defaultAuth;
  title: string = 'login.title';
  error: boolean = false;
  typeEmail: boolean = true;
  complaint: IPublicComplaint;
  file1: File = null;
  file2: File = null;
  fileName1: string = this.trans.instant('complaint.noFileChosen');
  fileName2: string = this.trans.instant('complaint.noFileChosen');
  contactBy: number = 0;
  submitComplaint: IPublicComplaint = null;
  status: string = 'edit';
  pageTitle: string = '';

  countyList: ISelectItems[] = [];
  typeOfBusinessList: ISelectItems[] = [];
  stateList: ISelectItems[] = [];
  submitted: boolean = false;

  public environment = environment;
  
  form = new UntypedFormGroup({
    busCatId: new UntypedFormControl('0'),
    countyId: new UntypedFormControl('', [Validators.required]),
    stateId: new UntypedFormControl(''),
    businessName: new UntypedFormControl('', [Validators.required, Validators.maxLength(50), Validators.pattern(/^[^/;?:@=&<>#%{}|\\^~\[\]]*$/)]),
    businessComplaint: new UntypedFormControl('', [Validators.required]),
    businessAddress1: new UntypedFormControl('', [Validators.maxLength(50)]),
    businessAddress2: new UntypedFormControl('', [Validators.maxLength(50)]),
    businessState: new UntypedFormControl('Oregon'),
    businessCity: new UntypedFormControl('', [Validators.required, Validators.maxLength(50)]),
    businessZipCode: new UntypedFormControl('', [Validators.pattern(/^\d{5}(-\d{4})?$/), Validators.maxLength(10)]),
    businessPhone: new UntypedFormControl('', [Validators.pattern(/^\s*\(?\s*([0-9]{3})\s*\)?\s*[-\s]?\s*([0-9]{3})\s*[-\s]?\s*([0-9]{4,})\s*.*$/)]),
    businessPhoneExt: new UntypedFormControl('', [Validators.maxLength(6)]),
    contactName: new UntypedFormControl('', [Validators.maxLength(50)]),
    contactAddress: new UntypedFormControl('', [Validators.maxLength(50)]),
    contactCity: new UntypedFormControl('', [Validators.maxLength(50)]),
    contactState: new UntypedFormControl('', [Validators.maxLength(255)]),
    contactZipCode: new UntypedFormControl('', [Validators.maxLength(10)]),
    contactPhone: new UntypedFormControl('', [Validators.pattern(/^\s*\(?\s*([0-9]{3})\s*\)?\s*[-\s]?\s*([0-9]{3})\s*[-\s]?\s*([0-9]{4,})\s*.*$/)]),
    // contactPhone: new UntypedFormControl('', [Validators.pattern(/^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4,}).*$/)]),
    contactPhoneExt: new UntypedFormControl('', [Validators.maxLength(6)]),
    contactEmail: new UntypedFormControl('', [Validators.email, Validators.maxLength(50)]),
    contactByEmail: new UntypedFormControl(false),
    contactByMail: new UntypedFormControl(false)
  });

  constructor(
    public settings: SettingsService,
    public sharedService: SharedService,
    public complaintService: PublicComplaintService,
    private trans: TranslateService,
    public dialog: MatDialog,
    @Inject(DOCUMENT) private document: Document,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.submitted = false;
    this.setBusinessList();
    this.contactBy = 0;
    this.countyList = this.sharedService.countyDropDownList;
    this.stateList = this.sharedService.stateDropdownList;
    this.setHtmlLang(this.trans.currentLang);
    this.pageTitle = this.trans.instant('complaint.header1') + ' - ' + this.trans.instant('complaint.title');
    this.trans.onLangChange.subscribe((event) => {
      this.setHtmlLang(event.lang);
      this.setBusinessList();
      this.form.controls['businessState'].setValue(this.trans.instant('complaint.oregon'));
      this.pageTitle = this.trans.instant('complaint.header1') + ' - ' + this.trans.instant('complaint.title');
      this.titleService.setTitle(this.pageTitle);
    });
    this.titleService.setTitle(this.pageTitle);
  }

  getCounties() {
    this.complaintService.getCounties().subscribe({
      next: response => {
        this.countyList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get addresses");
        console.log('Get addresses error', e);
      },
    });
  }

  setBusinessList() {
    this.typeOfBusinessList = [
      // { value: '0', text: '' },
      { value: '1', text: this.trans.instant('businessList.1') },
      { value: '2', text: this.trans.instant('businessList.2') },
      { value: '3', text: this.trans.instant('businessList.3') },
      { value: '4', text: this.trans.instant('businessList.4') },
      { value: '5', text: this.trans.instant('businessList.5') },
      { value: '6', text: this.trans.instant('businessList.6') },
      { value: '7', text: this.trans.instant('businessList.7') },
      { value: '8', text: this.trans.instant('businessList.8') },
      { value: '9', text: this.trans.instant('businessList.9') },
      { value: '10', text: this.trans.instant('businessList.10') },
      { value: '11', text: this.trans.instant('businessList.11') },
      { value: '12', text: this.trans.instant('businessList.12') },
      { value: '13', text: this.trans.instant('businessList.13') },
      { value: '14', text: this.trans.instant('businessList.14') },
      { value: '15', text: this.trans.instant('businessList.15') },
      { value: '16', text: this.trans.instant('businessList.16') },
      { value: '17', text: this.trans.instant('businessList.17') },
      { value: '18', text: this.trans.instant('businessList.18') },
      { value: '19', text: this.trans.instant('businessList.19') }
    ];
  }

  submitRequest(): void {
    let com = this.form.value;
    let bizPhone = '';
    let contactPhone = '';
    if (com.businessPhone != null && com.businessPhone != '') {
      bizPhone = com.businessPhone.replace(/[^0-9]/g, '').substring(0, 15);
    }    
    if (com.contactPhone != null && com.contactPhone != '') {
      contactPhone = com.contactPhone.replace(/[^0-9]/g, '').substring(0, 15);
    }

    if (this.form.valid) {
      if (!this.submitted) {
        this.submitted = true;
        let formData1 = new FormData();
        // const formData2 = new FormData();
        if (this.file1 != null) {
          formData1.append('file1', this.file1, this.file1.name);
        }
        if (this.file2 != null) {
          formData1.append('file2', this.file2, this.file2.name);
        }

        this.submitComplaint = {
          // business

          complaintId: 0,
          county: com.countyId,
          businessName: com.businessName,
          address: com.businessAddress1,
          address2: com.businessAddress2,
          city: com.businessCity,
          state: com.businessState,
          zip: com.businessZipCode,
          typeOfBusiness: "" + com.busCatId,
          businessPhone: bizPhone,
          businessPhoneExtension: com.businessPhoneExt,
          complaintComments: com.businessComplaint,

          // File Upload

          uploadId: 0,
          initialComplaintId: 0,
          fileContentType: this.file1 != null ? this.file1.type : this.file2 != null ? this.file2.type : '',
          fileExtension: this.file1 != null ? this.file1.type : this.file2 != null ? this.file2.type : '',
          fileName: 'file1',
          fileDescription: 'Complaint Uploads',

          // contact

          contactName: com.contactName,
          contactAddress: com.contactAddress,
          contactCity: com.contactCity,
          contactState: com.contactState,
          contactZip: com.contactZipCode,
          contactPhone: contactPhone,
          contactPhoneExtension: com.contactPhoneExt,

          contactEmail: com.contactEmail,
          contactEmailName: com.contactName,

          // contact Email

          isContactAnonymous: com.contactByMail,
          isContactAnonymousEmail: com.contactByEmail,
          lastUpdatedBy: '',
          lastUpdatedDate: new Date()
        }

        formData1.append('complaint', JSON.stringify(this.submitComplaint));
        this.complaintService.saveComplaint(formData1).subscribe(
          (response) => {
            if (response) {
              this.sharedService.toastr.success("Complaint Saved");
              this.status = 'done';
            }
            else {
              this.sharedService.toastr.error("Complaint Not Saved");
            }
          },
          error => {
            console.log('error', error);
            this.sharedService.toastr.error("Complaint Not Saved");
          }
        );
      }
    }
  }

  contactType(type: string, checkbox: MatCheckboxChange) {
    this.unRequire();
    this.contactBy = 0;
    if (type == 'email') {
      this.form.controls['contactByMail'].setValue(false);
      if (checkbox.checked) {
        this.contactBy = 1;
        this.form.controls['contactName'].addValidators(Validators.required);
        this.form.controls['contactEmail'].addValidators([Validators.required]);
      }
    }
    if (type == 'mail') {
      this.form.controls['contactByEmail'].setValue(false);
      if (checkbox.checked) {
        this.contactBy = 2;
        this.form.controls['contactName'].addValidators(Validators.required);
        this.form.controls['contactAddress'].addValidators([Validators.required]);
        this.form.controls['contactCity'].addValidators([Validators.required]);
        this.form.controls['contactState'].addValidators([Validators.required]);
        this.form.controls['contactZipCode'].addValidators([Validators.required]);
      }
    }
    this.typeEmail = this.form.controls['contactByEmail'].value;
  }

  unRequire() {
    this.form.controls['contactName'].removeValidators([Validators.required]);
    this.form.controls['contactName'].updateValueAndValidity();
    this.form.controls['contactEmail'].removeValidators([Validators.required]);
    this.form.controls['contactEmail'].updateValueAndValidity();
    this.form.controls['contactAddress'].removeValidators([Validators.required]);
    this.form.controls['contactAddress'].updateValueAndValidity();
    this.form.controls['contactCity'].removeValidators([Validators.required]);
    this.form.controls['contactCity'].updateValueAndValidity();
    this.form.controls['contactState'].removeValidators([Validators.required]);
    this.form.controls['contactState'].updateValueAndValidity();
    this.form.controls['contactZipCode'].removeValidators([Validators.required]);
    this.form.controls['contactZipCode'].updateValueAndValidity();
  }

  next() {
    
    if (this.form.valid) {
      this.error = false;
      this.fileName1 = this.file1 == null ?
        this.trans.instant('complaint.noFileChosen') : this.fileName1;
      this.fileName2 = this.file2 == null ?
        this.trans.instant('complaint.noFileChosen') : this.fileName2;
      this.status = 'list';
      this.pageTitle = this.trans.instant('complaint.header4') + ' - ' + this.trans.instant('complaint.title');
      this.titleService.setTitle(this.pageTitle);
    }
    else {
      this.error = true;
      this.sharedService.openNotice(this.trans.instant('validations.errorNotice'));
    }
  }

  editComplaint() {
    this.status = 'edit';
    this.pageTitle = this.trans.instant('complaint.header1') + ' - ' + this.trans.instant('complaint.title');
    this.titleService.setTitle(this.pageTitle);
  }

  uploadFile1(event): void {
    this.file1 = event.target.files[0];
    this.fileName1 = this.file1.name;
  }

  uploadFile2(event): void {
    this.file2 = event.target.files[0];
    this.fileName2 = this.file2.name;
  }

  removeFile1() {
    this.file1 = null;
    this.fileName1 = this.trans.instant('complaint.noFileChosen');
  }

  removeFile2() {
    this.file2 = null;
    this.fileName2 = this.trans.instant('complaint.noFileChosen');
  }

  fileTypes() {
    this.sharedService.openNotice(this.trans.instant('complaint.fileLimits'));
  }

  translateCounty(id: string): string {
    return this.countyList.find(x => x.value == id).text;
  }

  translateTypeOfBusiness(id: string): string {
    let type = id == '0' ? '' : this.typeOfBusinessList.find(x => x.value == id).text;
    return type;
  }

  getStateName(id: string): string {
    let stateTxt: string = '';
    if (id != undefined && id != '') {
      stateTxt = this.stateList.find(x => x.value == id).text;
    }
    return stateTxt;
  }

  setHtmlLang(lang: string) {
    this.document.documentElement.lang = lang;
  }

 gotoPage(page: string) {
    this.sharedService.doRedirect(page);
  }
}


